import { createApiHandler } from './handler';

const quoteRequests = {
  apiClient: null,
  path: '/admin/quote-requests',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default quoteRequests;
